/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

export const columns: TableColumn[] = [
    {
        Header: "tableCommon.sl_no",
        accessor: "slno",
      },
      {
        Header: "applicationConfiguration.tableColumns.deviceId",
        accessor: "device_code",
      },
      {
        Header: "applicationConfiguration.tableColumns.deviceName",
        accessor: "device_name",
      },
      {
        Header: "applicationConfiguration.tableColumns.remarks",
        accessor: "remarks",
      },
      
]


interface TableColumn {
    Header: string;
    accessor: string;
  }